const PdfList = ({ files }) => {
  return (
    <div className="pdf-list">
      {files.map((file, i) => (
        <div key={i} className="pdf-row">
          <p>{file.name}</p>
          <a href={file.pdf} target="_blank" rel="noreferrer">
            View
          </a>
        </div>
      ))}
    </div>
  );
};

export default PdfList;
